module.exports = __webpack_public_path__ + "img/aifxjz-4-sm.6f9abd76.jpg";